import * as types from './types';
import { windowSmallScreen } from '../../config/dev';

/** метод установки размера экрана */
export const setScreenSize = (size) => (dispatch) => {
  dispatch({ type: types.SET_SCREEN_SIZE, data: size });
  dispatch({ type: types.SET_SMALL_SCREEN, data: size <= windowSmallScreen })
};

